var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoverAbsentees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50684 34.0004C8.86013 31.9196 10.7117 30.2098 12.8934 29.0262C15.0752 27.8426 17.518 27.2227 20.0001 27.2227C22.4823 27.2227 24.9251 27.8426 27.1068 29.0262C29.2886 30.2098 31.1401 31.9196 32.4934 34.0004",
    stroke: "#1859B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 23.6129C23.9909 23.6129 27.226 19.6701 27.226 14.8064C27.226 9.94278 23.9909 6 20.0002 6C16.0095 6 12.7744 9.94278 12.7744 14.8064C12.7744 19.6701 16.0095 23.6129 20.0002 23.6129Z",
    stroke: "#1859B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverAbsentees);
export default __webpack_public_path__ + "static/media/hover-absentees.7562461bd10a2bdb9cd0d9eaf528fc94.svg";
export { ForwardRef as ReactComponent };